import { CheckOutlined } from '@mui/icons-material';
import styles from './FormActions.module.css';
import { Sparkles } from 'lucide-react';

export type FormPageMode = 'add' | 'edit' | 'view';

export interface FormActionsProps {
	mode?: FormPageMode;
	onDelete?: () => void;
	deleteInActions?: boolean;
	onEdit?: () => void;
	onView?: () => void;
	onIaAnalysis?: () => void;
	viewText?: string;
	onMix?: () => void;
	mixText?: string;
	onCancel?: () => void;
	onClear?: () => void;
	clearText?: string;
	clearDisabled?: boolean;
	onSecondary?: () => void;
	secondaryText?: string;
	secondaryDisabled?: boolean;
	secondaryLoading?: boolean;
	onSave?: () => void;
	isLoading?: boolean;
	saveText?: string;
	saveDisabled?: boolean;
}

export const FormActions = ({
	mode = 'add',
	onDelete,
	deleteInActions,
	onEdit,
	onView,
	onIaAnalysis,
	viewText = 'Visualizar',
	onMix,
	mixText = 'Elaborar mistura',
	onCancel,
	onClear,
	clearText = 'Limpar',
	clearDisabled,
	onSecondary,
	secondaryText,
	secondaryDisabled,
	secondaryLoading,
	onSave,
	isLoading,
	saveText = 'Salvar',
	saveDisabled,
}: FormActionsProps) => {
	if (mode === 'view') {
		return (
			<div className={styles.actions}>
				{onMix && (
					<button className={styles.editButton} onClick={onMix} type="button">
						{mixText}
					</button>
				)}
				{onIaAnalysis && (
					<button className={styles.iaAnalysisButton} onClick={onIaAnalysis} type="button">
						<>
							<Sparkles size={16} />
							Ver resumo da flora
						</>
					</button>
				)}
				{onDelete && (
					<button className={styles.deleteButton} onClick={onDelete} type="button">
						Excluir
					</button>
				)}
				{onView && (
					<button className={styles.editButton} onClick={onView} type="button">
						{viewText}
					</button>
				)}
				{onEdit && (
					<button className={styles.editButton} onClick={onEdit} type="button">
						Editar
					</button>
				)}
			</div>
		);
	}

	return (
		<div className={styles.actions}>
			{onClear && (
				<button
					className={styles.deleteButton}
					onClick={onClear}
					type="button"
					disabled={clearDisabled}
				>
					{clearText}
				</button>
			)}
			{!onClear && onCancel && (
				<button className={styles.cancelButton} onClick={onCancel} type="button" disabled={isLoading}>
					Cancelar
				</button>
			)}
			{deleteInActions && onDelete && (
				<button className={styles.deleteButton} onClick={onDelete} type="button" disabled={isLoading}>
					Excluir
				</button>
			)}
			{onSecondary && (
				<button
					className={styles.saveButton}
					onClick={onSecondary}
					type="button"
					disabled={secondaryDisabled}
				>
					{secondaryLoading ? <span className={styles.spinner} /> : null}
					{secondaryText}
				</button>
			)}
			{onSave && (
				<button className={styles.saveButton} onClick={onSave} type="button" disabled={isLoading || saveDisabled}>
					{isLoading ? <span className={styles.spinner} /> : <CheckOutlined />}
					{isLoading ? 'Salvando...' : saveText}
				</button>
			)}
		</div>
	);
};
